export var MARKETPLACE = 'Marketplace';
export var MARKETPLACE_NAMED_QUERIES = 'MarketplaceNamedQueries';